// components/CheckoutStep.jsx
import React from "react";
import { Box, Typography, Collapse, Paper } from "@mui/material";

const CheckoutStep = ({
  title,
  children,
  expanded,
  completed,
  disabled,
  onClick,
  summaryContent,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        mb: 3,
        p: 2,
        borderColor: expanded ? "primary.main" : "grey.300",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transition: "all 0.2s ease",
      }}
      onClick={!disabled ? onClick : undefined}>
      <Typography
        variant="h6"
        fontWeight="bold"
        color={disabled ? "text.disabled" : "text.primary"}
        sx={{ mb: 1 }}>
        {title}
      </Typography>

      <Collapse in={expanded}>
        <Box mt={2}>{children}</Box>
      </Collapse>

      {!expanded && completed && summaryContent && (
        <Box mt={2}>{summaryContent}</Box>
      )}
    </Paper>
  );
};

export default CheckoutStep;
